/* HH V4.01.01: Shopify search fields prevent napkin queries matching
   unrelated ties/robes because their descriptions mention table linens.
   Queries outside the napkin category retain Shopify's normal search.
*/
(() => {
  const napkinGate = '(title:napkin* OR product_type:napkin* OR tag:napkin*)';
  const isSearchPath = (pathname) => /\/search\/?$/.test(pathname);
  const scopeNapkins = (raw) => {
    if (!raw || /(?:title|body|tag|product_type|vendor|variants\.)\s*:/i.test(raw)) return null;
    if (!/\bnapkins?\b/i.test(raw)) return null;
    if (/\b(?:and|or|not)\b|[():"]/.test(raw)) return null;
    const terms = raw.trim().toLowerCase().split(/\s+/);
    if (terms.length > 6 || terms.some(s => !/^[\w'-]+$/.test(s))) return null;
    const extra = terms.filter(s => !/^napkins?$/i.test(s));
    return napkinGate + extra.map(s => ' AND ' + s).join('');
  };
  const searchLabel = (url, original) => {
    const term = url.searchParams.get('hh_term');
    if (term) return term;
    if (!original || !original.includes('title:napkin*')) return original || '';
    const tails = original.split(' AND ').slice(1);
    return [...tails, 'napkins'].join(' ');
  };
  const getUrl = () => new URL(window.location.href);
  const formSubmit = (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    let action;
    try { action = new URL(form.action, window.location.origin); } catch { return; }
    if (!isSearchPath(action.pathname)) return;
    const queryInput = form.querySelector('[name="q"]');
    if (!queryInput) return;
    const original = queryInput.value.trim();
    const normalized = scopeNapkins(original);
    const label = form.querySelector('[name="hh_term"]');
    if (label) label.remove();
    if (!normalized) return;
    queryInput.value = normalized;
    const hidden = document.createElement('input');
    hidden.type = 'hidden'; hidden.name = 'hh_term'; hidden.value = original;
    form.appendChild(hidden);
  };
  // Register early enough to rewrite before a search form GET request.
  document.addEventListener('submit', formSubmit, true);
  const url = getUrl();
  if (!isSearchPath(url.pathname)) return;
  const query = url.searchParams.get('q');
  if (query) {
    const rewritten = scopeNapkins(query);
    if (rewritten) {
      url.searchParams.set('q', rewritten);
      url.searchParams.set('type', 'product');
      url.searchParams.set('hh_term', query.trim());
      window.location.replace(url.pathname + url.search + url.hash);
      return;
    }
  }
  const label = searchLabel(url, query);
  const applyLabel = () => {
    const input = document.querySelector('.hh-search-form input[name="q"]');
    if (input) input.value = label;
    const count = document.querySelector('.hh-catalog__count');
    if (count && query && label !== query) {
      const text = count.textContent;
      count.textContent = text.replace('“' + query + '”','“' + label + '”');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyLabel);
  else applyLabel();
})();
